import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, mergeAll, Observable, toArray } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SessionInfo {
    idSessione: number;
    timestamp: string;
    volume_vuoto?: number | null;
    volume_prodotto?: number | null;
    peso_prodotto?: number | null;
    rating?: number | null;
    ordine_griglia: number;
    silo: number;
}

export interface SessionPoints {
    faces: number[];
    vertices: number[];
    punti_sph?: number[];
}

export interface EmptySessionPoints {
    faces: number[];
    vertices: number[];
}

interface SessioneResponse {
    id: number;
    timestamp: string;
    volume_vuoto?: number | null;
    volume_prodotto?: number | null;
    peso_prodotto?: number | null;
    rating?: number | null;
    ordine_griglia: number;
    silo: number;
}

interface PuntiResponse {
    mesh: number[];
    punti: number[];
    punti_sph?: number[];
}

@Injectable({
    providedIn: 'root'
})
export class SessionsService {

    constructor(private http: HttpClient) { }

    getSessionPoints$(siloId: number): Observable<SessionPoints> {
        return this.http.get<PuntiResponse>(`${environment.api2Url}/oye/sessione/${siloId}/punti/`).pipe(
            map((points: PuntiResponse) => {
                return {
                    faces: points.mesh,
                    vertices: points.punti,
                    punti_sph: points.punti_sph
                }
            }),
        );
    }

    getEmptySessionPoints$(siloId: string | number): Observable<EmptySessionPoints> {
        return this.http.get<PuntiResponse>(`${environment.api2Url}/oye/silo/${siloId}/punti_modello/`).pipe(
            map((points: PuntiResponse) => {
                return {
                    faces: points.mesh,
                    vertices: points.punti
                }
            }),
        );
    }

    getSessionInfos$(siloId: string | number): Observable<SessionInfo[]> {
        return this.http.get<SessioneResponse[]>(`${environment.api2Url}/oye/silo/${siloId}/sessioni/`).pipe(
            mergeAll(),
            map(siloSession => {
                const timestamp = this.toTimestamp(siloSession.timestamp)
                return {
                    idSessione: siloSession.id,
                    timestamp: timestamp.toString(),
                    volume_vuoto: siloSession.volume_vuoto,
                    volume_prodotto: siloSession.volume_prodotto,
                    peso_prodotto: siloSession.peso_prodotto,
                    rating: siloSession.rating ?? null,
                    ordine_griglia: siloSession.ordine_griglia,
                    silo: siloSession.silo,
                } as SessionInfo;
            }),
            toArray()
        )
    }

    private toTimestamp(strDate: string): number {
        const datum = Date.parse(strDate);
        return datum;
    }


}
